<script setup>
import UserForm from '@frontJs/components/forms/UserForm.vue';
import DefaultLayout from '@frontJs/layouts/DefaultLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

const { user, tenants } = defineProps({
    user: {
        required: false,
    },
    tenants: {
        required: true,
        type: Array,
    },
});

defineOptions({ layout: DefaultLayout });
</script>

<template>
    <Head>
        <title v-if="user">
            Mettre à jour l'utilisateur #{{ user.id }} - Utilisateurs -
            Datakepler
        </title>

        <title v-else>Utilisateurs - Créer un utilisateur</title>
    </Head>

    <PageTitle v-if="user">
        Utilisateurs - Mettre à jour l'utilisateur #{{ user.id }}
    </PageTitle>

    <PageTitle v-else> Utilisateurs - Créer un utilisateur </PageTitle>

    <UserForm :user="user" :tenants="tenants" />
</template>
